import { FC } from 'react';
import { DetailsBooking } from 'types';
import { getStayRatingForBookingId } from 'lib/stayRating';
import { getUpdatePaymentMethodPageLink } from 'lib/links';
import StateMessaging from '../BookingDetails/StateMessaging';
import StayRating from '../BookingDetails/StayRating';
import { TravelDocumentationReminder } from '../Alerts/Inline/TravelDocumentationReminder';
import { FailedScheduledPaymentContainer } from '../Alerts/Inline/FailedScheduledPayment';
import { ScheduledPaymentCreditCardExpiredContainer } from '../Alerts/Inline/ScheduledPaymentCreditCardExpired';
import { InPathFlightBookingAlert } from 'components/InPathFlightBookingAlert';
import { PaymentMethodUpdateRequired } from '../Alerts/Inline/PaymentMethodUpdateRequired';
import { showDepositPayAdyenMigrationInfo } from '../helpers';

interface BookingDetailsProps {
  booking: DetailsBooking;
}

const BookingNotifications: FC<BookingDetailsProps> = ({ booking }) => {
  const rating = getStayRatingForBookingId(booking.id);
  const showPaymentMethodUpdateRequired = showDepositPayAdyenMigrationInfo(booking);
  const showTravelDocumentationReminder = !booking.reservation.isAfterCheckOut && !booking.flags.isCancelled;

  return (
    <>
      {showPaymentMethodUpdateRequired && (
        <PaymentMethodUpdateRequired updatePaymentMethodUrl={getUpdatePaymentMethodPageLink(booking.id)} />
      )}
      {showTravelDocumentationReminder && <TravelDocumentationReminder />}
      <StateMessaging booking={booking} />
      <InPathFlightBookingAlert />

      <FailedScheduledPaymentContainer />
      <ScheduledPaymentCreditCardExpiredContainer />

      {booking.flags.isRateable && !rating && <StayRating booking={booking} />}
    </>
  );
};

export default BookingNotifications;
